// FTEDN — Skeleton loading component (shimmer)
import '../../styles/shared-ui.css';

interface SkeletonProps {
  variant?: 'text' | 'title' | 'circle' | 'card' | 'pill';
  width?: string;
  height?: string;
  count?: number;
}

export function Skeleton({ variant = 'text', width, height, count = 1 }: SkeletonProps) {
  const cls = `skeleton skeleton--${variant}`;
  const style = { width, height };

  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className={cls} style={style} />
      ))}
    </>
  );
}

/** Skeleton card with avatar row + text lines */
export function SkeletonCard() {
  return (
    <div className="skeleton--card">
      <div className="skeleton-row">
        <div className="skeleton skeleton--circle" style={{ width: 32, height: 32 }} />
        <div style={{ flex: 1 }}>
          <div className="skeleton skeleton--text" style={{ width: '40%' }} />
          <div className="skeleton skeleton--text" style={{ width: '25%', height: 10 }} />
        </div>
      </div>
      <div className="skeleton skeleton--text" style={{ width: '90%' }} />
      <div className="skeleton skeleton--text" style={{ width: '70%' }} />
    </div>
  );
}
